import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AccountSubheaderStyles";

export default class AccountSubheader extends Component {
  render() {
    const { isHistoryBack } = this.props;

    return (
      <div className={css(styles.subHeader)}>
        {isHistoryBack && (
          <button
            onClick={() => this.props.history.goBack()}
            className={css([styles.back, styles.subHeaderColumn])}
          >
            {this.props.backLabel ? this.props.backLabel : "Account"}
          </button>
        )}
        {!isHistoryBack && (
          <a
            href={this.props.backHref ? this.props.backHref : "/account"}
            className={css([styles.back, styles.subHeaderColumn])}
          >
            {this.props.backLabel ? this.props.backLabel : "Account"}
          </a>
        )}
        <h2 className={css([styles.title, styles.subHeaderColumn])}>
          {this.props.title ? this.props.title : "HomeView"}
        </h2>
        <div className={css(styles.subHeaderColumn)}>&nbsp;</div>
      </div>
    );
  }
}
